module.exports = "/fonts/HanaMinA.ttf?781e7982241c7ccc2a56d8dbf41a6fd7";